<template>
  <tr>
    <td :style="tdStyle" align="center">
      <table
        role="presentation"
        cellpadding="0"
        cellspacing="0"
        style="border-collapse: collapse; border-spacing: 0px"
        :align="align"
        border="0"
      >
        <tbody>
          <tr>
            <td :style="wrapperStyle">
              <a
                :href="link"
                @click.prevent="
                  $emit('open-settings', 'image');
                  openOptions();
                "
              >
                <svg
                  v-if="block.mode === 'dynamic'"
                  id="Layer_2"
                  :style="{
                    ...(imageStyle as any),
                    maxWidth: '120px',
                    marginInline: 'auto',
                  }"
                  data-name="Layer 2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 90.91 101.36"
                >
                  <g id="Icons">
                    <g>
                      <path
                        class="cls-1"
                        d="M90.86,28.28L77.41,0H13.51L.06,28.28H.06l-.06,73.08h90.91l-.06-73.08h0ZM87.02,28.28h-39.81V3.5h27.85l11.96,24.78ZM15.86,3.5h27.85v24.78H3.89L15.86,3.5ZM87.41,97.86H3.5V31.78h83.91v66.08Z"
                        fill="#797b7d"
                      />
                      <path
                        class="cls-1"
                        d="M64.09,56.9h-15.01l9.38-17.14h-19.1l-10.77,27.05h9.89l-10.23,24.36,35.83-34.28ZM33.76,63.32l7.98-20.05h10.82l-9.38,17.14h12.19l-17.36,16.61,5.75-13.69h-10Z"
                        fill="#797b7d"
                      />
                    </g>
                  </g>
                </svg>
                <img
                  v-else
                  :id="id"
                  :alt="alt"
                  title=""
                  height="auto"
                  :src="src"
                  :style="imageStyle"
                  :width="block.attributes['image-width']"
                />
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>

<script lang="ts" setup>
  import { StyleValue, computed } from "vue";
  import { useMjmlStore } from "@/stores/mjmlStore";

  const mjmlStore = useMjmlStore();

  const props = defineProps({
    block: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    columnIndex: {
      type: Number,
      required: true,
    },
    sectionIndex: {
      type: Number,
      required: true,
    },
    blockIndex: {
      type: Number,
      required: true,
    },
  });

  defineEmits(["open-settings"]);

  const id = computed(() => {
    return "img" + props.block.uid;
  });

  const align = computed(() => {
    return props.block.attributes["image-align"]
      ? props.block.attributes["image-align"]
      : "center";
  });

  const padding = computed(() => {
    return props.block.attributes["image-padding"]
      ? props.block.attributes["image-padding"]
      : "0px 0px 0px 0px";
  });

  const src = computed(() => {
    let src = props.item["image"];

    if (!src || src == "*|PRODUCT_IMG_SRC|*") {
      src = "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/pp1.png";
    }

    return src;
  });

  const alt = computed(() => {
    if (props.block.attributes["alt"]) {
      return props.block.attributes["alt"];
    }
    if (props.block.attributes["title"]) {
      return props.block.attributes["title"].replace(
        /<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g,
        ""
      );
    }
    return "";
  });

  const link = computed(() => {
    return props.item["href"];
  });

  const tdStyle = computed<StyleValue>(() => {
    return {
      padding: padding.value,
      "word-break": "break-word",
      "font-size": "0px",
    };
  });

  const wrapperStyle = computed<StyleValue>(() => {
    let width = props.block.attributes["image-width"] + "px";
    if (
      mjmlStore.isMobileFirstEnabled &&
      mjmlStore.isMobileView &&
      props.block.attributes["image-fluid-on-mobile"] === "true"
    ) {
      width = "100%";
    }
    return {
      width: width,
    };
  });

  const imageStyle = computed<StyleValue>(() => {
    return {
      border: "none",
      display: "block",
      outline: "none",
      "text-decoration": "none",
      width: "100%",
      height: "auto",
      "border-radius": props.block.attributes["image-border-radius"] || 0,
    };
  });

  function openOptions() {
    let timeoutTime = 400;
    if (
      document.querySelector(
        '[data-testid="product-description-tab"] [data-testid="t-tab-toggle-open"] button'
      )
    ) {
      timeoutTime = 10;
    }
    setTimeout(() => {
      const openSetting: HTMLElement = document.querySelector(
        '[data-testid="product-image-tab"] [data-testid="t-tab-toggle-open"] button'
      ) as HTMLElement;

      if (openSetting && !openSetting.classList.contains("!outline")) {
        openSetting.click();
      }

      if (openSetting) {
        setTimeout(() => {
          (document.querySelector(".scroll-area") as HTMLElement).scrollTop =
            openSetting.offsetTop - openSetting.offsetHeight;
        }, 100);
      }
    }, timeoutTime);
  }
</script>
